import {
    convertCurrencyFormatPositiveNegative,
    convertPersianDateToUniversalDate,
    convertUniversalDateTimeToPersianDateTime, DialogSize,
    RaikoBaseCardContainer, RaikoButtonPrimary,
    RaikoConfirmDialog,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoDatePicker, RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    showErrorMessage, showSuccessMessage,RaikoErrorSection
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useAuthState} from "../../../context/AuthContext";
import {AccountService} from "../../../serverService/account/AccountService";
import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {detectServerErrorMessage, getStatusCode} from "../../../util/detectServerErrorMessage";
import {RouteHelper} from "../../../route/RouteHelper";
import PointsStatistics from "../../../raicheComponents/statistics/PointsStatistics";
import useDraggableScroll from "use-draggable-scroll";

import AccountChooseGuardian from "./AccountChooseGuardian";

export default function AccountDetailBasicInfo({setUserFullName}) {

    const {fundID} = useAuthState()
    const {id: accountId} = useParams()

    const service = new AccountService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const navigate = useNavigate()

    const [accountDetail, setAccountDetail] = useState({
        enabled: true,
        guardianId: -1,
        guardianFirstName: "",
        guardianLastName: "",

        id: -1,
        cleared: false,
        clearedBy: "",

        balance: 0,
        initialBalance: 0,
        number: "",

        openedAt: "",
        openedBy: "",

        ownerFirstName: "",
        ownerId: -1,
        ownerLastName: ""
    });

    const [accountStatus, setAccountStatus] = useState({
        "numberOfLatePayments": 0,
        "numberOfNonPayments": 0,
        "numberOfInstallmentArrears": 0,
        "numberOfUnpaidInstallments": 0,
        "status": "",
        "dateOfLatestInstallmentPaid": "",
        "dateOfLatestLoan": "",
        "numberOfMonthsOfWaiting": 1
    });


    useEffect(() => {
        getBasicInfo()
        getAccountStatusDetail()
    }, []);

    function getBasicInfo() {
        loading.show()
        service.getAccountDetail(
            fundID,
            accountId
        ).then(response => {
            setAccountDetail(response)
            setUserFullName(`${response.ownerFirstName} ${response.ownerLastName}`)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function getAccountStatusDetail() {
        service.getAccountStatusInfo(
            fundID,
            accountId
        ).then(response => {
            setAccountStatus(response)
        }).catch(reason => {
            if (getStatusCode(reason) === 406) {
                setAccountStatus(null)
            } else
                showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {

        })
    }

    function ignoreFunction() {
        //nothing to do !!!
    }


    const [accountInfoLoadingButton, setAccountInfoLoadingButton] = useState(false);

    function handleUpdateAccountInfo() {
        setAccountInfoLoadingButton(true)

        service.updateAccountDetail(
            fundID,
            accountId,
            accountDetail.number,
            accountDetail.openedAt,
            accountDetail.enabled,
            accountDetail.guardianId
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setAccountInfoLoadingButton(false)
        })
    }


    const [banAccountLoading, setBanAccountLoading] = useState(false);

    function handleBanAccount() {
        setBanAccountLoading(true)
        service.clearAccount(fundID, accountId)
            .then(response => {
                closeConfirmDialog()
                showSuccessMessage("حساب کاربر با موفقیت بسته شد.")
                getBasicInfo()
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setBanAccountLoading(false)
        })
    }

    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false);
    const openConfirmDialog = () => setConfirmDialogOpenState(true)
    const closeConfirmDialog = () => setConfirmDialogOpenState(false)

    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});


    const [guardianDialogState, setGuardianDialogState] = useState(false)
    const handleOpenGuardian = () => setGuardianDialogState(true)
    const handleCloseGuardian = () => setGuardianDialogState(false)

    function handleChangeAccountGuardian(guardianInfo) {
        setAccountDetail(guardianInfo)
        handleCloseGuardian()
    }


    function handleDeleteGuardian() {
        loading.show()
        service.updateAccountDetail(
            fundID,
            accountId,
            accountDetail.number,
            accountDetail.openedAt,
            accountDetail.enabled,
            null
        ).then(response => {
            showSuccessMessage("قیم حساب با موفقیت حذف شد.")
            setAccountDetail(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                cancelAction={closeConfirmDialog}
                openConfirmDialog={confirmDialogOpenState}
                doAction={handleBanAccount}
                pageTitle={"بستن حساب"}
                confirmButtonTitle={"بستن حساب"}
                warningTitle={"آیا از بستن حساب اطمینان دارید؟"}
                warningDescription={"با اتمام روند امکان بازگشت وجود نخواهد داشت."}
            />

            <RaikoDefaultDialogPage
                onClose={handleCloseGuardian}
                open={guardianDialogState}
                pageTitle={"انتخاب قیم"}
                dialogSize={DialogSize.LARGE}
            >
                <AccountChooseGuardian
                    selectedGuardian={
                        accountDetail && accountDetail.guardianId ?
                            [
                                {
                                    id: accountDetail.guardianId,
                                    name: `${accountDetail.guardianFirstName} ${accountDetail.guardianLastName}`
                                }
                            ] :
                            []
                    }
                    changeGuardianInfo={handleChangeAccountGuardian}
                    accountInfo={accountDetail}
                />
            </RaikoDefaultDialogPage>

            <RaikoGridOneColumn className={css`gap: 1.5rem`}>

                {
                    accountStatus &&
                    <div className="statisticsLayout hideScroll" ref={ref} onMouseDown={onMouseDown}>

                        <PointsStatistics
                            title={"وضعیت کاربری"}
                            amount={accountStatus.status}
                            iconFile={""}
                        />
                        <PointsStatistics
                            title={"دیرکرد پرداخت"}
                            amount={accountStatus.numberOfLatePayments}
                            iconFile={""}
                        />
                        <PointsStatistics
                            title={"عدم پرداخت"}
                            amount={accountStatus.numberOfNonPayments}
                            iconFile={""}
                        />
                        <PointsStatistics
                            title={"اقساط تاخیر خورده"}
                            amount={accountStatus.numberOfInstallmentArrears}
                            iconFile={""}
                        />
                        <PointsStatistics
                            title={"اقساط پرداخت نشده"}
                            amount={accountStatus.numberOfUnpaidInstallments}
                            iconFile={""}
                        />
                    </div>
                }


                {
                    accountStatus &&
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer title={"اطلاعات وام"}>
                            <RaikoGridThreeColumn>
                                <RaikoMaterialOutlinedInput
                                    labelText={"آخرین وام دریافتی"}
                                    value={accountStatus.dateOfLatestLoan ? convertUniversalDateTimeToPersianDateTime(accountStatus.dateOfLatestLoan) : "-"}
                                    setValue={ignoreFunction}
                                    disabled
                                />
                                <RaikoMaterialOutlinedInput
                                    labelText={"آخرین قسط پرداختی"}
                                    value={accountStatus.dateOfLatestInstallmentPaid ? convertUniversalDateTimeToPersianDateTime(accountStatus.dateOfLatestInstallmentPaid) : "-"}
                                    setValue={ignoreFunction}
                                    disabled
                                />
                                <RaikoMaterialOutlinedInput
                                    labelText={"ماه انتظار"}
                                    value={accountStatus.numberOfMonthsOfWaiting ? accountStatus.numberOfMonthsOfWaiting : "-"}
                                    setValue={ignoreFunction}
                                    disabled
                                />
                            </RaikoGridThreeColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                }


                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"اطلاعات پایه"}
                        hasSecondaryButton
                        secondaryButtonTitle={"جزئیات کاربر"}
                        secondaryButtonOnClick={_ => {
                            navigate(`${
                                    RouteHelper.UserInformation.globalUrl.replace(":id", accountDetail.ownerId)
                                }`,
                                {
                                    state: {fullName: `${accountDetail.ownerFirstName} ${accountDetail.ownerLastName}`},
                                    replace: false
                                }
                            )
                        }}
                    >
                        <RaikoGridThreeColumn>
                            <RaikoMaterialOutlinedInput
                                labelText={"نام"}
                                value={accountDetail.ownerFirstName}
                                setValue={ignoreFunction}
                                disabled
                            />
                            <RaikoMaterialOutlinedInput
                                labelText={"نام"}
                                value={accountDetail.ownerLastName}
                                setValue={ignoreFunction}
                                disabled
                            />
                            <RaikoMaterialOutlinedInput
                                labelText={"موجودی (ریال)"}
                                value={convertCurrencyFormatPositiveNegative(accountDetail.balance)}
                                setValue={ignoreFunction}
                                disabled
                            />
                        </RaikoGridThreeColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"اطلاعات حساب"}
                        hasActionButton
                        actionButtonTitle={"بروزرسانی"}
                        actionButtonOnclick={handleUpdateAccountInfo}
                        actionButtonLoadingState={accountInfoLoadingButton}
                    >
                        <RaikoGridOneColumn>
                            <RaikoGridTwoColumn>
                                <RaikoNumberInputOutlined
                                    labelText={"شناسه حساب"}
                                    value={accountDetail.number}
                                    setValue={number => {
                                        let newValue = {
                                            ...accountDetail,
                                            number
                                        }

                                        setAccountDetail(newValue)
                                    }}
                                />
                                <RaikoCustomSelect
                                    labelText={"وضعیت"}
                                    value={accountDetail.enabled}
                                    setValue={enabled => {
                                        let newValue = {
                                            ...accountDetail,
                                            enabled
                                        }
                                        setAccountDetail(newValue)
                                    }}
                                    items={[
                                        raikoCustomSelectItemGenerator(true, "فعال"),
                                        raikoCustomSelectItemGenerator(false, "غیرفعال"),
                                    ]}/>
                            </RaikoGridTwoColumn>

                            <RaikoDatePicker
                                label={"تاریخ افتتاح"}
                                date={convertUniversalDateTimeToPersianDateTime(accountDetail.openedAt)}
                                setDate={newDate => {
                                    let newValue = {
                                        ...accountDetail,
                                        openedAt: convertPersianDateToUniversalDate(newDate)
                                    }
                                    setAccountDetail(newValue)
                                }}
                            />
                        </RaikoGridOneColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"قیم حساب"}
                        hasActionButton={accountDetail.guardianId && accountDetail.guardianId >= 0}
                        actionButtonTitle={"تغییر قیم"}
                        actionButtonOnclick={handleOpenGuardian}
                        hasSecondaryButton={accountDetail.guardianId && accountDetail.guardianId >= 0}
                        secondaryButtonTitle={"حذف قیم"}
                        secondaryButtonOnClick={handleDeleteGuardian}
                    >
                        {
                            accountDetail.guardianId && accountDetail.guardianId > 0 ?
                                <RaikoGridTwoColumn>
                                    <RaikoMaterialOutlinedInput
                                        labelText={"نام"}
                                        value={accountDetail.guardianFirstName}
                                        setValue={ignoreFunction}
                                        disabled
                                    />
                                    <RaikoMaterialOutlinedInput
                                        labelText={"نام خانوادگی"}
                                        value={accountDetail.guardianLastName}
                                        setValue={ignoreFunction}
                                        disabled
                                    />
                                </RaikoGridTwoColumn> :
                                <RaikoErrorSection
                                    title={"هیچ قیمی برای این حساب مشخص نشده است."}
                                    image={""}
                                >
                                    <div
                                        className={css`
                                          display: flex;
                                          justify-content: center;
                                          align-items: center;`}>
                                        <RaikoButtonPrimary
                                            label={"افزودن قیم جدید"}
                                            onClick={handleOpenGuardian}
                                        />
                                    </div>
                                </RaikoErrorSection>
                        }
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"وضعیت بستن حساب"}
                        hasActionButton={!accountDetail.cleared}
                        actionButtonTitle={"بستن حساب"}
                        actionButtonOnclick={openConfirmDialog}
                        actionButtonLoadingState={banAccountLoading}
                    >
                        <RaikoGridTwoColumn>
                            <RaikoMaterialOutlinedInput
                                labelText={"وضعیت"}
                                value={accountDetail.cleared ? "بسته شده" : "فعال"}
                                setValue={ignoreFunction}
                                disabled
                            />

                            <RaikoMaterialOutlinedInput
                                labelText={"تسویه کننده"}
                                value={accountDetail.clearedBy ? accountDetail.clearedBy : "ندارد"}
                                setValue={ignoreFunction}
                                disabled
                            />
                        </RaikoGridTwoColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>

        </>
    )
}
